// language=GraphQL
export const ALL_SLIDER_BLOCKS_QUERY = `query Query($withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
  sliderBlocks: cmsSliderBlocks {
    id
    fluid
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    size
    showDots
    showArrows
    showLightbox
    autoplay
  }
}`

// language=GraphQL
export const SINGLE_SLIDER_BLOCK_QUERY = `query Query($id: ID!, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
  sliderBlock: cmsSliderBlock(id: $id) {
    id
    fluid
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    size
    showDots
    showArrows
    showLightbox
    autoplay
  }
}`

// language=GraphQL
export const CREATE_SLIDER_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsSliderBlockInput, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
    sliderBlock: createCmsSliderBlock(input: $input) {
      id
      fluid
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      size
      showDots
      showArrows
      showLightbox
      autoplay
    }
  }`

// language=GraphQL
export const UPDATE_SLIDER_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsSliderBlockInput, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
    sliderBlock: updateCmsSliderBlock(input: $input) {
      id
      fluid
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      size
      showDots
      showArrows
      showLightbox
      autoplay
    }
  }`

// language=GraphQL
export const DELETE_SLIDER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsSliderBlockInput) {
    deleteCmsSliderBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_SLIDER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsSliderBlockInput) {
    forceDeleteCmsSliderBlock(input: $input) {
      success
    }
  }`
